var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('small',[_vm._v("Tags:")]),_vm._v(" "),_vm._l((_vm.tags.split(', ')),function(tag){return _c('span',{staticClass:"label label-info"},[_vm._v(_vm._s(tag))])})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }